import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Link } from 'foundations-components/transitional/components/Link';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useState } from 'react';
import { KeyTypes } from '../constants/popover';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function MorphingPopoverBody(props) {
  const {
    title,
    children
  } = props;
  const {
    tokenProps
  } = filterTokenProps(props);
  const {
    paddingInline,
    paddingBlockStart
  } = tokenProps;
  const hasMorphButtonTitle = ('morphButtonTitle' in props);
  const [showMorphedContent, setShowMorphedContent] = useState(false);
  if (hasMorphButtonTitle && showMorphedContent) {
    const {
      morphedContentTitle,
      renderMorphedContent
    } = props;
    const handleCloseMorphedContent = () => {
      setShowMorphedContent(false);
    };
    const handleCloseOnEscape = evt => {
      if (evt.key === KeyTypes.ESCAPE) {
        handleCloseMorphedContent();
      }
    };
    return /*#__PURE__*/_jsxs("div", {
      "data-test-id": "morphed-content",
      onKeyDown: handleCloseOnEscape,
      tabIndex: -1,
      children: [/*#__PURE__*/_jsxs(TFlex, {
        marginBlockEnd: "200",
        direction: "column",
        paddingInline: paddingInline,
        paddingBlockStart: paddingBlockStart,
        children: [/*#__PURE__*/_jsx(Breadcrumbs, {
          flush: true,
          marginBlockStart: "0",
          children: /*#__PURE__*/_jsx(Link, {
            "data-test-id": "morphed-content-back-button",
            onClick: handleCloseMorphedContent,
            onMouseDown: evt => evt.preventDefault(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'RichTextLib.morphing.back'
            })
          })
        }), /*#__PURE__*/_jsx(H4, {
          marginBlockEnd: "0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: morphedContentTitle
          })
        })]
      }), renderMorphedContent({
        onCloseMorphedContent: handleCloseMorphedContent
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(TFlex, {
      paddingInline: paddingInline,
      paddingBlockStart: paddingBlockStart,
      align: "baseline",
      justify: "between",
      children: [/*#__PURE__*/_jsx(H4, {
        marginBlockEnd: "0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: title
        })
      }), hasMorphButtonTitle && /*#__PURE__*/_jsx(Button, {
        "data-test-id": "morph-content-button",
        use: "transparent",
        paddingInlineEnd: "0",
        onClick: () => setShowMorphedContent(true),
        onMouseDown: evt => evt.preventDefault(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: props.morphButtonTitle
        })
      })]
    }), children]
  });
}
MorphingPopoverBody.displayName = 'MorphingPopoverBody';
export default MorphingPopoverBody;